import axios from "axios";
import type { VerifyData } from "~/lib/api/types/verify";

export async function verify(): Promise<VerifyData> {
    const response = await axios.get<VerifyData>("/app/verify");

    return response.data;
}
